module.exports = __webpack_public_path__ + "img/energetic2.e68a3f58.png";